import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-flag',
  imports: [],
  templateUrl: './flag.html',
  styleUrl: './flag.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Flag {
  withLangText = input(false);
  language = input.required({
    transform: (value: string) => value.toLowerCase(),
  });
  svgHeight = input(18, {
    transform: (value: string | number | undefined) => !value ? value : `${value}px`
  });
  svgWidth = input(24, {
    transform: (value: string | number | undefined) => !value ? value : `${value}px`
  });
}
